import { render, staticRenderFns } from "./DevRankingsByMatchday.vue?vue&type=template&id=63323b9f&scoped=true"
import script from "./DevRankingsByMatchday.vue?vue&type=script&lang=js"
export * from "./DevRankingsByMatchday.vue?vue&type=script&lang=js"
import style0 from "./DevRankingsByMatchday.vue?vue&type=style&index=0&id=63323b9f&prod&lang=scss"
import style1 from "./DevRankingsByMatchday.vue?vue&type=style&index=1&id=63323b9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63323b9f",
  null
  
)

export default component.exports